<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header
        pageTitle="Manage Banking Offices"
        class="card-container"
      ></Header>
      <div class="col-md-12">
        <div class="row">
          <export-group :name="'Banking Offices'" :excelUrl="`api/adminbankingoffice/excel`" :getData="filterExport"></export-group>


          <div class="col-md-5 col-sm-6 col-xs-6 align-right">


             <create-banking-office @on-close="() =>this.getBankingOfficesFromBackend() ">
              <template  v-slot:modal-link>
                <span class="btn btn-secondary more-margin-top">
                    <i class="tim-icons icon-simple-add"></i> Create New Banking Office</span>
             
              </template>
            </create-banking-office>

            <!-- <router-link
              :to="'/Admin/CreateBankingOffice'"
              class="btn btn-secondary more-margin-top"
            >
              <span
                ><i style="height: 18px;" class="tim-icons icon-simple-add"></i> Create New Banking
                Office</span
              >
            </router-link> -->
          </div>

          <div class="col-md-3 ">
            <label for="searchBox">Search:</label>
            <el-input
              id="searchBox"
              type="search"
              class="mb-3 search-input"
              clearable
              prefix-icon="el-icon-search"
              placeholder="Search all Banking Offices..."
              v-model="searchText"
              v-b-popover.hover.bottom="
                'Search results appear immediately upon typing.'
              "
            ></el-input>
          </div>
        </div>
      </div>
      <div style="margin-top: 20px !important; margin-left: 20px !important;" class="row">
        <div class="col-md-3">
          <label for="filterByCountry">Filter by Country:</label>
          <v-select
            id="filterByCountry"
            v-model="selectedCountry"
            name="CountriesDropdown"
            :reduce="(item) => item.countryId"
            label="name"
            :options="allCountriesOptions"
            placeholder="Select"
            v-b-popover.hover.left="
              'If a country filter is not selected, search results will pull for all countries.'
            "
          ></v-select>
        </div>
      </div>
     
      <div style="margin-right: 20px !important; margin-left: 20px !important;" class="row">
        <el-table :data="paginatedBankingOffices" role="table"
        aria-label="Admin Banking Offices Table">
          <el-table-column :min-width="180" align="left" label="Actions">
            <div slot-scope="props">
              <banking-edit :id="props.row.id">
              <template  v-slot:modal-link>
                <span class="btn-link btn-primary">
                                               <i class="tim-icons icon-pencil"></i> <span class="hide-if-small-screensize">Edit</span>
              </span>
              </template>
            </banking-edit>

              <span class="hide-if-medium-screensize">|</span>

              <a
                href="##"
                @click="
                  deleteBankingOffice(
                    props.row.id,
                    props.row.bankName
                  )
                "
                class="btn-link btn-danger"
              >
                <i class="tim-icons icon-trash-simple"></i>
                <span class="hide-if-small-screensize">Delete</span>
              </a>
            </div>
          </el-table-column>
          <el-table-column :min-width="150" align="left" label="Country">
            <div slot-scope="props">
              {{ getCountryLabel(props.row.countryId) }}
            </div>
          </el-table-column>
          <el-table-column
            v-for="column in tableColumns"
            sortable
            :key="column.label"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
          ></el-table-column>
        </el-table>
      </div>
      <div class="row justify-content-end">
        <label for="ResultsPerPageDropdown" class="results-per-page"
          >Results Per Page:</label
        >
        <el-select
          id="ResultsPerPageDropdown"
          v-model="selectedResultsPerPage"
          readonly="false"
          name="PageOptions"
          class="select-primary"
        >
          <el-option
            v-for="(item, index) in getResultsPerPageOptions"
            :value="item"
            class="select-primary"
            :key="index"
          ></el-option>
        </el-select>

        <base-pagination
          :perPage="selectedResultsPerPage"
          v-model="selectedPage"
          :pageCount="this.pagination.pageSize"
        />
      </div>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BasePagination, ExportGroup } from "@/components";
import BankingEdit from "@/components/App/office/BankingEdit.vue";
import CreateBankingOffice from "@/components/App/office/CreateBankingOffice.vue";
import { Option, Select } from "element-ui";
import { Table, TableColumn } from "element-ui";
import Util from "@/util/util";
import Header from "@/components/App/Header";
import axios from "@/axios";
import swal from "sweetalert2";

export default {
  name: "AdminBankingOfficesDashboard",
  components: {
    Header,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    BasePagination,
    ExportGroup,
    BankingEdit,
    CreateBankingOffice
  },
  data() {
    return {
      selectedCountry: "",
      map: {
          "Id": "id",
          "AccountName" : "accountName",
          "BankName": "bankName",
          "BankAddress": "bankAddress",
          "Iban": "iban",
          "Swift": "swift",
      },
      tableColumns: [
        {
          prop: "accountName",
          label: "Account Name",
          scope: "col",
          minWidth: "180"
        },
        {
          prop: "bankAddress",
          label: "Bank Address",
          scope: "col",
          minWidth: "180"
        },
        {
          prop: "bankName",
          label: "Bank Name",
          scope: "col",
          minWidth: "150"
        },
        {
          prop: "iban",
          label: "IBAN",
          scope: "col",
          minWidth: "150"
        },
        {
          prop: "swift",
          label: "SWIFT",
          scope: "col",
          minWidth: "150"
        }
      ],
      searchText: "",
      searchTimeOut: null,
      selectedResultsPerPage: 5,
      selectedPage: 1,
    };
  },
  watch: {
    searchText() {
      clearTimeout(this.searchTimeOut);

      var self = this;
      self.searchTimeOut = setTimeout(function () {
        self.pageNumber = 1;
        self.getBankingOfficesFromBackend();
      }, 1000);
    },
    selectedCountry() {
      this.pageNumber = 1;
      this.getBankingOfficesFromBackend();
    },
    selectedResultsPerPage() {
      this.getBankingOfficesFromBackend();
    },
    selectedPage() {
      this.getBankingOfficesFromBackend();
    },
  },
  async created() {
    this.$loaderApp.addRequest();
    await this.getAllCountries();
    this.getBankingOfficesFromBackend();
    this.$loaderApp.completeRequest();
  },
  computed: {
    ...mapGetters({
      allCountriesOptions: "countries/allCountries",
      paginatedBankingOffices: "bankingOffice/paginatedBankingOffices",
      allBankingOffices: "bankingOffice/allBankingOffices",
      pagination: "bankingOffice/pagination",
    }),
    getResultsPerPageOptions() {
      return Util.getInitialPaginationInfo().perPageOptions;
    },
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
      getPaginatedBankingOffices: "bankingOffice/getPaginatedBankingOffices",
      getAllBankingOffices:"bankingOffice/getAllBankingOffices",
    }),
    async filterExport() {
      await this.getAllBankingOffices({
        searchText: this.searchText,
        countryId: this.selectedCountry
      });

      return Util.mapTheData(this.allBankingOffices, this.map);
    },
    getCountryLabel(countryId) {
      if(this.allCountriesOptions && this.allCountriesOptions.length > 0) {
        const country = this.allCountriesOptions.filter(country => country.id === countryId);
      return country[0].label;
      }

      return '';
    },
    async getBankingOfficesFromBackend() {
      let apiInfo = {
        pageNumber: this.selectedPage,
        resultsPerPage: this.selectedResultsPerPage,
        exportToExcel: this.exportToExcelFlag,
        searchText: this.searchText,
      };
      apiInfo.countryId = this.selectedCountry;
      await this.getPaginatedBankingOffices(apiInfo);
    },
    deleteBankingOffice(bankingOfficeId, bankingOfficeName) {
      new swal({
        title: "Delete Confirmation",
        text: `Do you want to delete: "${bankingOfficeName}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        reverseButtons: true,
        cancelButtonColor: "red",
        confirmButtonText: `Delete Banking Office!`,
      }).then((result) => {
        if (result.value) {
          axios
            .delete(`api/adminbankingoffice/${bankingOfficeId}`)
            .then((response) => {
              new swal({
                title: "Confirmation of Delete",
                text: `"${bankingOfficeName}" has been deleted successfully.`,
                icon: "success",
                confirmButtonColor: "#10b45a",
              });
              this.getBankingOfficesFromBackend();
            });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
